import * as THREE from 'three'
import { beats, type Beats } from './beats.ts'

// One mutable frame-state object shared by the rig, every system, and the DOM copy.
// Written once per frame by FlightRig (priority -100), read by everyone else.
export const frame = {
  targetP: 0, // raw scroll progress (set by the scroll driver)
  p: 0, // critically damped progress — the only clock the world runs on
  beats: beats(0) as Beats,
  bg: new THREE.Color('#F2F5F7'),
  devFlow: -1, // dev slider override (?dev), -1 = off
  devP: -1,
}
